<div class="animated fadeIn">
  <div class="row settings">
    <div class="col-md-6 settings__title">
      <h1>Subscriptions</h1>
    </div>
    @if (subscriptions().length) {
    @if (!globalPauseDate().length && !isWaitingForAPIResponse()) {
    <div class="col-md-6 settings__right-element">
      <button type="button" class="d-none d-sm-inline btn btn-primary fw-bold" (click)="openModalPause()"
        [disabled]="isWaitingForAPIResponse()"> PAUSE SUBSCRIPTIONS </button>
    </div>
    }
    @if (isTemporaryRouteChange()) {
    <app-empty-message [message]="temporaryRouteChangeMessage()"></app-empty-message>
    }
    } @else {
    <app-empty-message [message]="emptyMessage"></app-empty-message>
    <hr>
    }
  </div>

  @let firstGlobalPause = globalPauseDate()[0] || null;
  @if(firstGlobalPause?.start) {
  <div class="d-grid w-100">
    <div class="p-4 bg-warning bg-opacity-10 rounded-1 d-flex flex-column" [class.w-100]="isMobile()"
      [class.w-max-content]="!isMobile()" role="alert">
      <!-- <span class="material-symbols-outlined text-primary"> event </span> -->
      @if (globalPauseDate().length === 1) {
      <p class="m-0 fw-medium">You’ve scheduled a pause for your subscriptions:</p>
      } @else {
      <p class="m-0 fw-medium">You’ve scheduled pauses for your subscriptions.</p>
      }
      <section>
        <p class="m-0 fst-italic">
          @if(globalPauseDate().length > 1) {
          <b>#1:</b>
          }
          From
          <span class="fw-medium text-primary">
            {{ firstGlobalPause.start }}
          </span>
          to
          <span class="fw-medium text-primary">
            {{ firstGlobalPause.end }}
          </span>
        </p>
      </section>
      @if (shouldShowAllPauses()) {
      <section class="animated fadeIn">
        @for (pause of globalPauseDate(); track $index) {
        @if($index > 0) {
        <p class="m-0 fst-italic">
          <b>#{{$index + 1}}:</b>
          From
          <span class="fw-medium text-primary">
            {{ pause.start }}
          </span>
          to
          <span class="fw-medium text-primary">
            {{ pause.end }}
          </span>
        </p>
        }
        }
      </section>
      }
      @if (globalPauseDate().length > 1) {
      <hr class="w-100 my-1">
      <section class="d-flex justify-content-between mt-2 w-100">
        <a href="javascript:void(0)" class="icon-link icon-link-hover link-underline-primary h7-semibold"
          (click)="toggleAllPauses()">
          Show {{shouldShowAllPauses() ? 'Less' : 'More'}}
        </a>
        <section class="d-flex gap-3 justify-content-between">
          <a href="javascript:void(0)" class="icon-link icon-link-hover link-underline-primary h7-semibold"
            (click)="openModalResume()">
            <i class="fas fa-trash"></i> Remove All
          </a>
          <a href="javascript:void(0)" class="icon-link icon-link-hover link-underline-primary h7-semibold"
            (click)="openModalEditPause()">
            <i class="fas fa-edit"></i> Edit
          </a>
        </section>
      </section>
      } @else {
      <hr class="w-100 my-1">
      <section class="d-flex justify-content-end mt-2 w-100 gap-3">
        <a href="javascript:void(0)" class="icon-link icon-link-hover link-underline-primary h7-semibold"
          (click)="openModalResume()">
          <i class="fas fa-trash"></i> Remove
        </a>
        <a href="javascript:void(0)" class="icon-link icon-link-hover link-underline-primary h7-semibold"
          (click)="openModalEditPause()">
          <i class="fas fa-edit"></i> Edit
        </a>
      </section>
      }
    </div>
  </div>
  } @if (subscriptions().length) {
  @if (!isMobile()) {
  <div class="row mt-2 animated fadeIn">
    <div class="col table-responsive">
      <table class="table align-middle">
        <thead>
          <tr>
            <th class="border-0 text-body-tertiary" scope="col">
              Product
            </th>
            <th class="border-0 text-body-tertiary" scope="col">Frequency</th>
            <th class="border-0 text-body-tertiary" scope="col">Quantity</th>
            <th class="border-0 text-body-tertiary" scope="col">
              Next delivery
            </th>
            <th class="border-0 text-body-tertiary" scope="col"></th>
          </tr>
        </thead>
        <tbody class="">
          @for (sub of subscriptions(); track $index) {
          @let pauseDate = sub?.pauseDate?.[0] || null;
          <tr class="fw-semibold">
            <td>
              <a [routerLink]="['/shop/' + sub.product.productUrl]" class="text-decoration-none">
                <h5 class="mb-1">{{ sub.product.name }}</h5>
              </a>
              <div class="d-flex flex-column gap-1">
                <h6 class="text-success-emphasis mb-0">
                  {{ sub.product.category.name }}
                </h6>
                @if(sub.package?.name) {
                <small class="text-body-secondary fw-normal">
                  <i class="fas fa-box me-1"></i>{{ sub.package?.name }}
                </small>
                }
              </div>
            </td>
            <td class="td-150">
              <mat-form-field class="w-100 normalized-mat-control">
                <mat-label>Frequency</mat-label>
                <mat-select [(value)]="sub.frequency" [disabled]="isTemporaryRouteChange()" (selectionChange)="
                    triggerUpdate({
                      subscription: sub,
                      event: $event,
                      isQuantity: false
                    })
                  ">
                  @for (freq of frequencies(); track $index) {
                  <mat-option [value]="freq.id">{{ freq.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </td>
            <td class="td-150">
              <a class="icon-link icon-link-hover link-underline-primary" href="javascript:void(0)"
                (click)="openModalChangeQuantity(sub)">
                {{ sub.quantity }}
                <i class="fas fa-edit"></i>
              </a>
            </td>
            <td>
              <a class="icon-link icon-link-hover link-underline-primary" href="javascript:void(0)" (click)="triggerUpdate({
                subscription: sub,
                event: $event,
                isQuantity: false,
                isDeliveryChange: true
              })">
                {{ sub.shownNextDelivery }}
                @if(!(!!pauseDate?.startDate && sub.isPauseActive)) {
                <i class="fas fa-edit"></i>
                }
              </a>
            </td>
            <td class="w-max-content">
              @if (!!pauseDate?.startDate && sub.isPauseActive) {
              <div class="text-body-tertiary">
                <h6 class="mb-0 fw-bold">Paused subscription</h6>
                <p class="m-0">
                  <small class="fw-normal">{{ pauseDate?.startDate }} -
                    {{ pauseDate?.endDate }}</small>
                </p>
                <p class="m-0">
                  <small class="fw-bold">Next delivery after pause:</small>
                </p>
                <p class="m-0">
                  <small class="fw-normal">{{
                    pauseDate?.nextDeliveryAfterPause
                    }}</small>
                </p>
                <small>
                  <a href="javascript:void(0)" class="h7-bold link-color" (click)="openModalCancel(sub)">
                    Cancel Subscription
                  </a>
                </small>
              </div>

              } @else {
              @if(!!sub.skipDate) {
              <div class="d-grid col-12 justify-content-end">
                <div class="alert alert-warning bg-opacity-50 d-flex align-items-center gap-3 w-max-content px-3"
                  role="alert">
                  <span class="material-symbols-outlined">
                    info
                  </span>
                  <div class="d-grid">
                    <p class="m-0">Skipped delivery day:</p>
                    <small class="fw-bold">{{ sub.skipDate }}</small>
                    <div class="d-flex w-max-content gap-2 justify-content-center align-items-center float-end">
                      <small>
                        <a href="javascript:void(0)" class="h7-bold link-color" (click)="undoSkipLine(sub)">
                          Unskip Week
                        </a>
                      </small>
                      <small>|</small>
                      <small>
                        <a href="javascript:void(0)" class="h7-bold link-color" (click)="openModalCancel(sub)">
                          Cancel
                        </a>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              } @else {
              <div class="d-flex w-max-content gap-2 justify-content-center align-items-center float-end">
                @if (sub.existsInOrder) {
                <small>
                  <a href="javascript:void(0)" class="h7-bold link-color" (click)="openModalSkip(sub)">
                    Skip This Week
                  </a>
                </small>
                <small>|</small>
                }
                <small>
                  <a href="javascript:void(0)" class="h7-bold link-color" (click)="openModalCancel(sub)">
                    Cancel
                  </a>
                </small>
              </div>
              } }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  } @else {
  <div class="mt-3 vstack gap-3 animated fadeIn">
    @for (sub of subscriptions(); track $index) {
    @let pauseDate = sub?.pauseDate?.[0] || null;
    <div class="vstack gap-1">
      <!-- Product name and subscription frequency -->
      <p class="m-0">Product</p>
      <div class="hstack gap-2">
        <section class="vstack w-50">
          <!-- <b>{{ sub.product.name }}</b> -->
          <a [routerLink]="['/shop/' + sub.product.productUrl]" class="text-decoration-none">
            <h5>{{ sub.product.name }}</h5>
          </a>
          <small>{{ sub.product.producer }}</small>
        </section>
        <section class="w-50">
          <mat-form-field class="w-100 float-end m-0 normalized-mat-control">
            <mat-label>Frequency</mat-label>
            <mat-select [(value)]="sub.frequency" [disabled]="isTemporaryRouteChange()" (selectionChange)="
                triggerUpdate({
                  subscription: sub,
                  event: $event,
                  isQuantity: false
                })
              ">
              @for (freq of frequencies(); track $index) {
              <mat-option [value]="freq.id">{{ freq.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </section>
      </div>
      <!-- Subscription quantity -->
      <div class="hstack gap-2">
        <section class="w-50">
          <b>Quantity</b>
        </section>
        <section class="w-50 text-end">
          <a class="icon-link icon-link-hover link-underline-primary" href="javascript:void(0)"
            (click)="openModalChangeQuantity(sub)">
            {{ sub.quantity }}
            <i class="fas fa-edit"></i>
          </a>
        </section>
      </div>
      @if (sub.package) {
      <!-- Package -->
      <div class="hstack gap-2">
        <section class="w-50">
          <b>Package</b>
        </section>
        <section class="w-50 text-end">
          <span>{{ sub.package.name }}</span>
        </section>
      </div>
      }
      <!-- Next delivery -->
      <div class="hstack gap-2 mt-2">
        <section class="w-50">
          <b>Next delivery</b>
        </section>
        <section class="w-50 text-end">
          <a class="icon-link icon-link-hover link-underline-primary" href="javascript:void(0)" (click)="triggerUpdate({
            subscription: sub,
            event: $event,
            isQuantity: false,
            isDeliveryChange: true
          })">
            {{ sub.shownNextDelivery }}
            @if(!(!!pauseDate?.startDate && sub.isPauseActive)) {
            <i class="fas fa-edit"></i>
            }
          </a>
        </section>
      </div>
      <!-- actions -->
      <div class="hstack gap-2 mt-2">

        @if (!!pauseDate?.startDate && sub.isPauseActive) {
        <div class="text-body-tertiary">
          <h6 class="mb-0 fw-bold">Paused subscription</h6>
          <p class="m-0">
            <small class="fw-normal">{{ pauseDate?.startDate }} -
              {{ pauseDate?.endDate }}</small>
          </p>
          <p class="m-0">
            <small class="fw-bold">Next delivery after pause:</small>
          </p>
          <p class="m-0">
            <small class="fw-normal">{{
              pauseDate?.nextDeliveryAfterPause
              }}</small>
          </p>
          <small>
            <a href="javascript:void(0)" class="h7-bold link-color" (click)="openModalCancel(sub)">
              Cancel Subscription
            </a>
          </small>
        </div>
        } @else {
        @if(!!sub.skipDate) {
        <div class="d-grid col-12">
          <div class="alert alert-warning bg-opacity-50 d-flex align-items-center gap-3 px-3 w-auto" role="alert">
            <span class="material-symbols-outlined">
              info
            </span>
            <div class="d-grid">
              <p class="m-0">Skipped delivery day:</p>
              <small class="fw-bold">{{ sub.skipDate }}</small>
              <div class="d-flex w-max-content gap-2 justify-content-center align-items-center float-end">
                <small>
                  <a href="javascript:void(0)" class="h7-bold link-color" (click)="undoSkipLine(sub)">
                    Unskip Week
                  </a>
                </small>
                <small>|</small>
                <small>
                  <a href="javascript:void(0)" class="h7-bold link-color" (click)="openModalCancel(sub)">
                    Cancel
                  </a>
                </small>
              </div>
            </div>
          </div>
        </div>
        } @else {
        <section class="w-50">
          <a href="javascript:void(0)" class="fw-bold h7-bold link-color" (click)="openModalCancel(sub)">
            Cancel
          </a>
        </section>
        @if (sub.existsInOrder) {
        <section class="w-50">
          <a href="javascript:void(0)" class="float-end h7-bold link-color" (click)="openModalSkip(sub)">
            Skip This Week
          </a>
        </section>
        }
        } }
      </div>
    </div>
    <hr class="mt-2 mb-0" />
    }
    @if (!globalPauseDate().length && !isWaitingForAPIResponse()) {
    <button type="button" class="d-sm-none btn btn-primary fw-bold" (click)="openModalPause()">
      PAUSE SUBSCRIPTIONS
    </button>
    }
  </div>

  }
  }
</div>

<!-- PRE ORDERS -->
@if(preorders().length) {
<div class="col-md-6 settings__title mt-2 animated fadeInLeft">
  <h1>Pre Orders</h1>
</div>

<app-empty-message [displayIcon]="false" [width100]="true" [message]="preOrdersDisclaimer()"
  [isHtml]="true"></app-empty-message>

<section>
  @for (item of preorders(); track $index) {
  <app-pre-ordered-product [product]="item" (ou_lineUpdated)="afterPreOrderLineUpdated()"></app-pre-ordered-product>
  }
</section>

}

<!-- PRE ORDERS: ENDS -->